// Tracking constants for link to dashboards modal
export const TRACKING_ACTION_CLICK_DASHBOARD_LINK = 'click_dashboard_link';
export const TRACKING_ACTION_CLICK_DASHBOARD_ITEM = 'click_dashboard_item';

export const TRACKING_LABEL_AI_CATALOG_HEADER = 'ai_catalog_header';
